import { Link } from "react-router-dom";
import { ROUTES } from "@/config/routes";
import { formatPdfsCell } from "@/domain/export/formatExportList";
import { formatExportTitle } from "@/domain/export/formatExportTitle";
import { ExportActionsCell } from "@/features/exports/components/ExportActionsCell";
import { ExportStatusBadge } from "@/features/exports/components/ExportStatusBadge";
import {
  DataTableShell,
  tableClass,
  tdClass,
  thClass,
} from "@/features/exports/components/DataTableShell";
import { formatDateTime } from "@/utils/format/date";
import type { ExportJobDetail } from "@/types/api";

export function RecentExportsTable({ items }: { items: ExportJobDetail[] }) {
  if (!items.length) {
    return (
      <p className="px-4 py-6 text-sm text-[var(--muted)]">
        No exports yet. Start from{" "}
        <Link to={ROUTES.invoicesPdfs} className="link-quiet">
          Download Invoice PDFs
        </Link>
        .
      </p>
    );
  }

  return (
    <DataTableShell>
      <table className={tableClass}>
        <thead>
          <tr>
            <th className={thClass}>Export</th>
            <th className={thClass}>Status</th>
            <th className={thClass}>PDFs</th>
            <th className={thClass}>Created</th>
            <th className={`${thClass} text-center`}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((job) => (
            <tr key={job.job_id}>
              <td className={tdClass}>
                <Link
                  to={ROUTES.exportDetail(job.job_id)}
                  className="link-quiet font-medium"
                >
                  {formatExportTitle(job)}
                </Link>
              </td>
              <td className={tdClass}>
                <ExportStatusBadge status={job.status} />
              </td>
              <td className={`${tdClass} tabular-nums text-sm`}>
                {formatPdfsCell(job)}
              </td>
              <td className={`${tdClass} text-sm text-[var(--muted)]`}>
                {formatDateTime(job.created_at)}
              </td>
              <td className={`${tdClass} text-center`}>
                <ExportActionsCell job={job} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </DataTableShell>
  );
}
